import { initBotId } from "botid/client/core";

// Server Actions POST to the current page URL. LFB (and other forms) mount via
// Site Builder on [[...slugs]], so protect all page POSTs.
initBotId({
  protect: [{ method: "POST", path: "/*" }],
});
